'use client'

import { memo, useCallback, useMemo } from 'react'
import { useTranslations } from "next-intl";
import { checkoutStepSelector, placeOrderReadySelector, shippingReadySelector } from '@segway/core'
import { useAppSelector } from '@segway/core/src/store/hooks'

import { Button } from '@/ui'

const ProceedOrder = ({ onNext }: { onNext: () => void }) => {
  const shippingReady = useAppSelector(shippingReadySelector)
  const placeOrderReady = useAppSelector(placeOrderReadySelector)
  const checkoutStep = useAppSelector(checkoutStepSelector)
  const tCommon = useTranslations('Common')

  const nextReady = useMemo(() => {
    return shippingReady
  }, [shippingReady])

  const handleNext = useCallback(() => {
    onNext()
  }, [onNext])

  // TODO: Place Order button
  if (checkoutStep === 1) {
    return placeOrderReady ? (
      <div />
    ) : /*<div className="fixed bottom-0 left-0 w-full bg-white p-3 pt-5 xl:static xl:mt-[32px]">
        <div className="text-[12px] text-[#6E6E73] xl:text-[14px]">
          {`Segway's Sales of Goods T&C (including Arbitration & Restocking Fee)`}
        </div>
        <Button className="mt-[32px] h-[45px] w-full rounded-full text-[16px] xl:h-[56px]">
          Proceed Order
        </Button>
      </div>*/
    null
  }

  return nextReady ? (
    <div className="fixed bottom-0 left-0 z-[10] w-full bg-white p-3 pt-5 xl:static xl:mt-[32px] xl:p-0">
      <Button onClick={handleNext} className="h-[45px] w-full rounded-full text-[16px] xl:h-[56px]">
        {tCommon('next')}
      </Button>
    </div>
  ) : null
}

export default memo(ProceedOrder)
